import React, { useState } from 'react';

import { Box, Collapse, Grid, IconButton } from '@mui/material';
import AdminChatBox from './AdminChatBox';

const AdminChat = () => {
  // State
  const [isChatOpen, setIsChatOpen] = useState(true);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  return (
    <Grid item>
      <div style={{ position: 'sticky', top: 'calc(64px + 15px)' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'stretch',
            width: isChatOpen ? '350px' : '40px',
            transition: 'width 0.3s ease-in-out',
          }}
        >
          <Collapse in={isChatOpen} orientation="horizontal">
            <AdminChatBox
              isChatOpen={isChatOpen}
              toggleChatCollapse={toggleChat}
            />
          </Collapse>
        </Box>
        {!isChatOpen ? (
          <Box
            sx={{
              position: 'fixed',
              top: '200px',
              right: 0,
            }}
          >
            <IconButton
              onClick={toggleChat}
              sx={{
                backgroundColor: '#F8FAFC',
                borderRadius: '5px',
              }}
            >
              <img
                style={{ width: '22px', height: '18px' }}
                src={`${process.env.PUBLIC_URL}/images/chat/chat-collapse.png`}
                alt="chat-collapse"
              />
            </IconButton>
          </Box>
        ) : null}
      </div>
    </Grid>
  );
};

export default AdminChat;
